"use strict";

import Tab from 'bootstrap/js/dist/tab';

function getTabIdFromUrl() {
    if (location.hash) {
        return location.hash.substring(1);
    }
    return new URLSearchParams(location.search).get('tab');
}

function scrollNavLinkIntoView(trigger) {
    const nav = trigger.closest('.nav-tabs--scrollable');
    if (nav) {
        trigger.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
}

function activateTabById(tabId) {
    const trigger = document.querySelector(`[data-bs-toggle="tab"][data-bs-target="#${tabId}"]`);
    if (trigger) {
        Tab.getOrCreateInstance(trigger).show();
    }
}

export function init() {
    const tabTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tab"]'));
    tabTriggerList.forEach(function (tabTriggerEl) {
        new Tab(tabTriggerEl);
    });

    tabTriggerList.forEach(function (triggerEl) {
        triggerEl.addEventListener('shown.bs.tab', function (e) {
            const target = e.target.getAttribute('data-bs-target');
            if (target) {
                history.replaceState(null, '', target);
            }
            scrollNavLinkIntoView(e.target);
        });
    });

    const tabId = getTabIdFromUrl();
    if (tabId) {
        activateTabById(tabId);
    }
}